<template>
  <div>
    <div
      ref="modal_validate_restock"
      id="modal_validate_restock"
      class="modal modal-right fade footer-fix"
      data-backdrop="static"
      role="dialog"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content" ref="section">
          <div class="modal-header bg-dark">
            <h6 class="modal-title">
              <span>
                {{ $t("Manage Product Stock") }}
              </span>
            </h6>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              @click="closeModal()"
            >
              ×
            </button>
          </div>

          <div class="modal-body p-0 pb-5 px-0" v-if="onload">
            <div class="content">
              <placeholder-content is-load="true" />
            </div>
          </div>

          <div v-if="!onload">
            <div v-show="!hasPermission" class="modal-body p-0 pb-5 px-0">
              <access-denied />
            </div>
            <div v-show="hasPermission">
              <div class="modal-body p-0 pb-5 px-0">
                <div class="px-0">
                  <legend
                    class="font-size-lg mb-0 px-3 py-2"
                    style="margin-bottom: 15px; color: black"
                  >
                    <i class="fa-solid fa-boxes-stacked mr-1" />
                    {{ $t("Product Lists") }}
                  </legend>
                </div>
                <div class="content">
                  <div class="row">
                    <div class="col-12">
                      <div class="d-flex mb-3">
                        <div class="pl-0 d-flex col-auto">
                          <div
                            class="d-flex w-100 justify-content-center align-self-center"
                            style="color: #324148; text-transform: capitalize;">
                            {{ $t("_restocks.Select Warehouse") }}:
                          </div>
                        </div>
                        <div class="col-md-4 text-value">
                          <Select2
                            id="warehouse"
                            v-model="warehouseId"
                            name="warehouse"
                            :options="options"
                            :settings="settings"
                            @change="onChangeWarehouses"
                            :disabled="loadingTable == 'loading'"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="border rounded">
                        <div :class="['datatable-scroll', loadingTable]">
                          <div class="table-responsive mt-0 main-scroll data-nowrap rounded">
                            <div class="vuetable-wrapper ui basic segment">
                              <vuetable
                                ref="productValidate"
                                data-path="data"
                                :no-data-template="$t('No Data Available')"
                                style="width: max-content; min-width: 100%"
                                class="dataTable thead-bg-fafafa customvuetb"
                                :data-manager="dataManager"
                                :fields="fields"
                                :api-mode="false"
                                @vuetable:checkbox-toggled="toggleCheckboxs"
                                @vuetable:checkbox-toggled-all="
                                  toggleAllCheckboxes
                                "
                                @vuetable:loading="showLoader"
                                @vuetable:loaded="hideLoader"
                                :row-class="onRowClass"
                                >
                                <div
                                  slot="channel_logo"
                                  slot-scope="props"
                                >
                                  <ChannelsLogoComponent
                                    :product-id="props.rowData.id"
                                    :channels-name="props.rowData.channel_name"
                                    :channels-image-url="
                                    props.rowData.channel_logo"
                                  />
                                </div>
                                <div
                                  slot="image"
                                  slot-scope="props"
                                >
                                  <ProductImageComponent
                                    :product-id="props.rowData.id"
                                    :product-image-url="props.rowData.image"
                                  />
                                </div>
                                <div
                                  slot="name"
                                  slot-scope="props"
                                >
                                  <div class="font-weight-semibold item-name">
                                    <router-link
                                      :to="{ name: 't.a.products', query: {productId: props.rowData.id}}"
                                      target="_blank"
                                      >
                                      <ProductNameComponent
                                        v-if="props.rowData.link_id != ''|| props.rowData.link_id != null"
                                        :product-name="props.rowData.name"
                                        :product-sku="props.rowData.sku"
                                        :product-link="props.rowData.link_id"
                                      />
                                      <ProductNameComponent
                                        v-else
                                        :product-name="props.rowData.link_name != '' ? props.rowData.link_name : props.rowData.name"
                                        :product-sku="props.rowData.sku"
                                      />
                                    </router-link>
                                  </div>
                                </div>
                                <div
                                  slot="stock_deduction"
                                  slot-scope="props"
                                >
                                  <table class="custom-vuetb-shipmentdata">
                                    <tbody>
                                      <div v-if="props.rowData.set_items.length > 0">
                                        <tr v-for="(listData,id) in props.rowData.set_items" :key="id">
                                          <td
                                            class="pb-2 pl-0 pt-0"
                                            style="width: 90px;">
                                            <router-link
                                              v-if="listData.product_name != ''"
                                              :to="{ name: 't.a.products', query: {productId: listData.product_id }}"
                                              target="_blank"
                                              >
                                              <ProductNameComponent
                                                :product-name="listData.product_name"
                                                :product-sku="listData.product_sku"
                                              />
                                            </router-link>
                                            <span v-else>-</span>
                                          </td>
                                        </tr>
                                      </div>
                                      <div v-else>
                                        <tr>
                                          <!-- :to="{ name: 't.a.products', query: {productId: props.rowData.id }}" -->
                                            <span v-if="props.rowData.link_name == '' || props.rowData.link_name == null">-</span>
                                            <router-link
                                              v-else
                                              :to="{ name: 't.a.productlink', query: {productLinkId: props.rowData.link_id}}"
                                              target="_blank"
                                              >
                                              <ProductNameComponent
                                                :product-name="props.rowData.link_name"
                                                :product-sku="props.rowData.product_sku"
                                                :show-line-second="false"

                                              />
                                            </router-link>

                                        </tr>
                                      </div>

                                    </tbody>
                                  </table>
                                </div>
                                <div
                                  slot="quantity"
                                  slot-scope="props"
                                >
                                  <table class="custom-vuetb-shipmentdata">
                                    <tbody>
                                      <div v-if="props.rowData.set_items.length > 0">
                                        <tr v-for="(listData,id) in props.rowData.set_items" :key="id">
                                          <td
                                            class="pl-0 pt-0"
                                            style="width: 90px; padding-bottom: 27px;">
                                            <span>{{ listData.quantity | formatNumberNotZero}}</span>
                                          </td>
                                        </tr>
                                      </div>
                                      <div v-else>
                                        <tr>
                                          <td
                                            class="pl-0"
                                            style="width: 90px; padding-bottom: 27px;">
                                            <span>{{ props.rowData.quantity | formatNumberNotZero}}</span>
                                          </td>
                                        </tr>
                                      </div>

                                    </tbody>
                                  </table>
                                </div>
                                <div
                                  slot="status"
                                  slot-scope="props"
                                >
                                  <table class="custom-vuetb-shipmentdata">
                                    <tbody>
                                      <div v-if="props.rowData.set_items.length > 0">
                                        <tr v-for="(listData,id) in props.rowData.set_items" :key="id">
                                          <td
                                            class="pl-0"
                                            style="width: 90px; padding-bottom: 27px;">
                                            <div v-if="loadingTable == 'loading'">
                                              <span
                                                :key="id"
                                              >
                                                <i class="icon-spinner2 spinner" />
                                              </span>
                                            </div>
                                            <div v-else>
                                              <span
                                                v-if="listData.status_validate && listData.status_validate != 'READY_TO_ADJUSTMENT'"
                                                class="text-danger"
                                              >
                                                <i class="fa-solid fa-circle-exclamation mr-1" />
                                                <span
                                                  v-if="listData.status_validate == 'NOT_WAREHOUSE'"
                                                >
                                                  {{ $t('Not Warehouse') }}
                                                </span>
                                                <span
                                                  v-if="listData.status_validate == 'NOT_AVAILABLE'"
                                                >
                                                  {{ $t('Stock Not Available') }}
                                                </span>
                                              </span>
                                              <span
                                                v-else
                                                class="text-green-custom"
                                              >
                                                <i class="fa-solid fa-circle-check mr-1" />
                                                {{ $t('Adjustment') }}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>

                                      </div>
                                      <div v-else>
                                        <tr>
                                          <td
                                            class="pl-0"
                                            style="width: 90px; padding-bottom: 27px;">
                                            <div v-if="loadingTable == 'loading'">
                                              <span
                                              >
                                                <i class="icon-spinner2 spinner" />
                                              </span>
                                            </div>
                                            <div v-else>
                                              <span
                                                v-if="props.rowData.status_validate && props.rowData.status_validate != 'READY_TO_ADJUSTMENT'"
                                                class="text-danger"
                                              >
                                                <i class="fa-solid fa-circle-exclamation mr-1" />
                                                <span
                                                  v-if="props.rowData.status_validate == 'NOT_WAREHOUSE'"
                                                >
                                                  {{ $t('Not Warehouse') }}
                                                </span>
                                                <span
                                                  v-if="props.rowData.status_validate == 'NOT_AVAILABLE'"
                                                >
                                                  {{ $t('Stock Not Available') }}
                                                </span>
                                              </span>
                                              <span
                                                v-else
                                                class="text-green-custom"
                                              >
                                                <i class="fa-solid fa-circle-check mr-1" />
                                                {{ $t('Adjustment') }}
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                      </div>
                                    </tbody>
                                  </table>
                                </div>
                              </vuetable>
                            </div>
                          </div>
                          </div>
                        </div>

                    </div>
                  </div>
                </div>
              </div>
              <div
                class="card-footer fixed-bottom bg-light d-flex justify-content-between"
              >
                <div>
                  <button
                    @click="previous()"
                    type="button"
                    class="btn btn-light text-left"
                  >
                    <i class="fas fa-arrow-circle-left mr-2"></i>
                    {{ $t("Previous") }}
                  </button>
                </div>

                <div>
                  <ladda
                    @click="submitToCreateAdjustment"
                    :text="`${$t('Create Quantity Adjustment')} (${selectedTo.length})`"
                    :btn-class="'btn btn-primary'"
                    :loading="btnLoading"
                    :disabled="!selectedTo.length"
                    icon="<i class='fa-solid fa-circle-plus'></i>"
                  />

                  <button
                    @click="closeModal()"
                    type="button"
                    class="btn btn-light"
                  >
                    {{ $t("Cancel") }}
                  </button>
                </div>

                <div></div>
              </div>
            </div>
          </div>
        </div>
        <!-- check showPlaceholder -->
      </div>
    </div>
  </div>
</template>
<script>
import Api from "@/services/endpoint/tenant.service";
import Vuetable from "vuetable-2";
import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
import AccessDenied from "@/components/tenancy/admin/error-page/templates/AccessDenied.vue";
import ProductNameComponent from "@/components/tenancy/center/ProductNameComponent.vue";
import ProductImageComponent from "@/components/tenancy/center/ProductImageComponent.vue";
import ChannelsLogoComponent from "@/components/tenancy/center/ChannelsLogoComponent.vue";
import FieldsDefValidateProducts from "../assets/FieldsDefValidateProducts";
import Select2 from "v-select2-component";
import Cookies from 'js-cookie'
import Ladda from "@/plugins/Ladda.vue";
import numeral from "numeral";

export default {
  name: "ModalValidateRestock",
  components: {
    Vuetable,
    PlaceholderContent,
    AccessDenied,
    ProductNameComponent,
    ProductImageComponent,
    ChannelsLogoComponent,
    Select2,
    Ladda,
  },
  props: {
    products: {
      type: [Array],
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      onload: true,
      loadingTable: "",
      btnLoading: false,
      hasPermission: false,
      fields: FieldsDefValidateProducts,
      warehouseLists: [],
      warehouse: {},
      warehouseId: null,
      dropdownCssClass: 'sales-select-search',
      options: [],
      settings: {
        language: {
          minimumResultsForSearch: Infinity,
          searching: () => {
            return this.$t('Searching...');
          }
        },
        placeholder: {
          id: "",
          text: this.$t("Select warehouse...."),
        },
        templateResult: this.templateCustom,
        templateSelection: this.templateSelectWarehouse,
        ajax: {
          cache: true,
          delay: 250,
          beforeSend: function (request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + Api.AUTH.TOKEN
            );
          },
          url:
            Api.AUTH.URL + Api.URL.SHIPMENTS_GETWAREHOUSE + "?page=1&limit=10",
          data: function (params) {
            const query = {
              search: params.term,
              page: params.page || 1,
              limit: params.limit || 10,
            };
            return Api.Signature.create($.param(query)).substring(1);
          },
          processResults: (data) => {
            let option = data.data;
            let pageCurrent = data.meta.current_page

            this.warehouseLists = option;

            option = option.map(function(item) {
              return {
                id: item.id,
                text: item.name,
                color: item.color,
                isDefault: item.is_default,
                address: item.address + ' ' + item.city + ' ' + item.state + ' ' + item.postcode,
                disabled: item.disabled
              }
            })

            return {
              results: option,
              pagination: {
                more: pageCurrent * 10 < data.meta.total,
              },
            };
          },
        },
      },
      productLists: [],
      features: JSON.parse(Cookies.get('features')),
      validateStocks: [],
      adjustmentBody: {
        product_ids: [],
        order_ids: [],
        adjustment_items: [],
        warehouse_id: null
      },
      selectedTo: [],
      disabledTo: [],
    };
  },
  filters: {
    formatNumberNotZero: function(value) {
      return numeral(value).format("0,0");
    }
  },
  async created() {
    await this.setProducts();
    await this.validateProducts();
  },
  mounted() {
    this.openModal();

    // after close modal
    $("#modal_validate_restock").on("hidden.bs.modal", (e) => {
      this.$parent.isRestockValidateModal = false;
    });
  },
  methods: {
    async setProducts() {
      this.onload = true;

      const getWarehouseList = await Api.ShipmentV2.getWarehouseList("?is_default=1")

      if (this.$storeIndex.isset(() => getWarehouseList.data.data[0])) {
        this.options = [
          {
            id: getWarehouseList.data.data[0].id,
            text: getWarehouseList.data.data[0].name,
            isDefault: getWarehouseList.data.data[0].is_default
          }
        ]

        this.warehouse = getWarehouseList.data.data[0];
        this.warehouseId = getWarehouseList.data.data[0].id.toString();
      }
      let products = JSON.parse(JSON.stringify(this.products))

      for (let product of products) {
        let setItemsMap = {};

        product.sales_order.forEach((order) => {
          order.items.forEach((item) => {
            if (item.product_id === product.id) {
              item.set_items.forEach((setItem) => {
                if (!setItemsMap[setItem.product_id]) {
                  setItemsMap[setItem.product_id] = { ...setItem };
                } else {
                  setItemsMap[setItem.product_id].quantity += setItem.quantity;
                }
              });
            }
          });
        });

        product.set_items = Object.values(setItemsMap);
      }
      this.productLists = products

      this.onload = false;
    },
    async validateProducts() {
      this.loadingTable = "loading";

      try {
        let selectedTo = this.selectedTo = [];
        let disabledTo = this.disabledTo = [];

        const warehouseId = this.warehouseId;

        let stocks = {
          wms_ids: [],
          warehouse_id: parseInt(warehouseId)
        };

        for (let product of this.productLists) {
          let wmsId = ""
          if (!product.product_wms_has_stock) {
            if (!product.set_items.length) {
              disabledTo.push(product.id)
              product.status_validate = "NOT_WAREHOUSE";
            } else {
              for (let sets of product.set_items) {
                sets.status_validate = "NOT_WAREHOUSE";
              }
            }
          }
          if (!product.set_items.length) {
            wmsId = product.wms_id;
            if (product.wms_link_id && product.link_id && this.features.includes("feature-product-link")) {
              wmsId = product.wms_link_id
            }

            if (!stocks.wms_ids.includes(wmsId) && wmsId) {
              stocks.wms_ids.push(wmsId);
            }
          } else {
            for (let sets of product.set_items) {
              wmsId = sets.product_wms_id;
              if (sets.product_wms_link_id && sets.product_link_id && this.features.includes("feature-product-link")) {
                wmsId = sets.product_wms_link_id
              }

              if (!stocks.wms_ids.includes(wmsId) && wmsId) {
                stocks.wms_ids.push(wmsId);
              }
            }
          }
        };
        await Api.ShipmentV2.getValidateStock({
          stocks: [
            stocks
          ]
        }).then((validate) => {
          if (this.$storeIndex.isset(() => validate.data.data[0].products)) {
            this.validateStocks = validate.data.data[0].products;

            for (let product of this.productLists) {
              let wmsId = "";
              if (!product.set_items.length) {
                wmsId = product.wms_id;
                if (product.wms_link_id && product.link_id && this.features.includes("feature-product-link")) {
                  wmsId = product.wms_link_id
                }

                let validateStocks = this.validateStocks.find(product => product.wms_id == wmsId);

                if (validateStocks) {
                  let currentAvailableQty = validateStocks.available_qty -= parseInt(product.quantity);
                  if (currentAvailableQty < 0) {
                    product.status_validate = "NOT_AVAILABLE";
                    disabledTo.push(product.id)
                    continue
                  }
                  selectedTo.push(product.id)
                  product.status_validate = "READY_TO_ADJUSTMENT";
                } else {
                  disabledTo.push(product.id)
                  product.status_validate = "NOT_WAREHOUSE";
                }
              } else {
                for (let sets of product.set_items) {
                  wmsId = sets.product_wms_id;
                  if (sets.product_wms_link_id && sets.product_link_id && this.features.includes("feature-product-link")) {
                    wmsId = sets.product_wms_link_id
                  }

                  let validateStocks = this.validateStocks.find(product => product.wms_id == wmsId);

                  if (validateStocks) {
                    let currentAvailableQty = validateStocks.available_qty -= parseInt(sets.quantity);
                    if (currentAvailableQty < 0) {
                      sets.status_validate = "NOT_AVAILABLE";
                      continue
                    }
                    sets.status_validate = "READY_TO_ADJUSTMENT";
                  } else {
                    sets.status_validate = "NOT_WAREHOUSE";
                  }
                }

                const checkStatusReady = product.set_items.filter(set => set.status_validate != "READY_TO_ADJUSTMENT");
                if (checkStatusReady.length) {
                  disabledTo.push(product.id)
                  product.status_validate = checkStatusReady[0].status_validate;
                } else {
                  selectedTo.push(product.id)
                  product.status_validate = "READY_TO_ADJUSTMENT";
                }
              }
            }
          }
        }).catch((error) => {
          disabledTo = this.productLists.map(item => item.id);
          console.log('validate error :', error)
        });


        this.selectedTo = selectedTo;
        this.disabledTo = disabledTo;

        this.$refs.productValidate.selectedTo = selectedTo
      } catch (error) {
        console.log('error', error)
      }
      this.loadingTable = "";
    },
    async submitToCreateAdjustment() {
      this.btnLoading = "loading";

      const productLists = this.productLists.filter(product => product.status_validate == "READY_TO_ADJUSTMENT" && this.selectedTo.includes(product.id));
      if (productLists.length) {
        let productIds = [];
        let orderIds = [];
        let adjustmentItems = new Set();
        for (let product of productLists) {
          if (!productIds.includes(product.id)) {
            productIds.push(product.id);
          }
          for (let order of product.sales_order) {
            if (!orderIds.includes(order.order_id)) {
              orderIds.push(order.order_id);
            }
          }

          let wmsId = ""
          if (!product.set_items.length) {
            wmsId = product.wms_id;
            if (product.wms_link_id && product.link_id && this.features.includes("feature-product-link")) {
              wmsId = product.wms_link_id
            }

            adjustmentItems.add({
              id: wmsId,
              type: 'out',
              quantity: parseInt(product.quantity),
            })

          } else {
            for (let sets of product.set_items) {
              wmsId = sets.product_wms_id;
              if (sets.product_wms_link_id && sets.product_link_id && this.features.includes("feature-product-link")) {
                wmsId = sets.product_wms_link_id
              }

              adjustmentItems.add({
                id: wmsId,
                type: 'out',
                quantity: parseInt(sets.quantity),
              })
            }
          }
        }

        let groupedAdjustments = {};

        Array.from(adjustmentItems).forEach(adjust => {
            if (!groupedAdjustments[adjust.id]) {
                groupedAdjustments[adjust.id] = { ...adjust };
            } else {
                groupedAdjustments[adjust.id].quantity += adjust.quantity;
            }
        });

        this.adjustmentBody = {
          product_ids: productIds,
          order_ids: orderIds,
          adjustment_items: Object.values(groupedAdjustments),
          warehouse: this.warehouse
        }


        this.closeModal()
        $('#modal_validate_restock').on('hidden.bs.modal', (e) => {
          this.$parent.isRestockValidateModal = false;
          this.$parent.isAdjustmentModal = true;
          this.$parent.adjustment = this.adjustmentBody;
        })
      }

      this.btnLoading = false;
    },
    async dataManager(sortOrder, pagination) {
      return {
          data: this.productLists
      };
    },
    toggleCheckboxs(event) {
      this.selectedTo = this.$refs.productValidate.selectedTo;
    },
    toggleAllCheckboxes(event) {
      this.$refs.productValidate.selectedTo = this.$refs.productValidate.selectedTo.filter( (el) => ! this.disabledTo.includes(el));
      this.selectedTo = this.$refs.productValidate.selectedTo;
    },
    showLoader() {},
    hideLoader() {},
    onRowClass(dataItem, index) {
      let dataIndex = this.disabledTo.indexOf(dataItem.id);
      if (dataIndex > -1) {
          return 'disabled'
      }
    },
    async onChangeWarehouses() {
      const warehouse = this.warehouseLists.find(wh => wh.id == this.warehouseId);
      if (warehouse) {
        this.warehouse = warehouse;
      }
      await this.validateProducts();
    },
    templateCustom: function (option) {
      if($('.select2-search--dropdown .select2-search__field').attr('placeholder') == undefined){
        $('.select2-search--dropdown .select2-search__field').attr('placeholder',this.$t('Search'))
      }
      if (!option.id) {
        return $(
          `<div class="loading-small p-0" style="z-index:9999; height:0;"></div>`
        );
      } else {
        if (!option.name) {
          option.name = option.text;
        }
        let optionName = option.name;
        let txtIsDefault = this.$t('Default')
        let txt = $(
          `<div class='list-item d-flex templatecustom'><div class='item-content'><div class='item-name'>${optionName}</div></div></div>`
        );
        let txtDefault = $(
          `<div class='list-item d-flex templatecustom'><div class='item-content'><div class='item-name'>${optionName} (${txtIsDefault})</div></div></div>`
        );
        return option.isDefault ? txtDefault : txt;
      }
    },
    templateSelectWarehouse: function (option) {
      if (!option.name) {
        option.name = option.text;
      }
      let optionName = option.name;
      let txtIsDefault = this.$t('Default')
      let txt = $(
        `<div class='list-item d-flex templateselect'"><div class='item-content'><div class='item-name'>${optionName}</div></div></div>`
      );
      let txtDefault = $(
          `<div class='list-item d-flex templatecustom'><div class='item-content'><div class='item-name'>${optionName} (${txtIsDefault})</div></div></div>`
        );
      return option.isDefault ? txtDefault : txt;
    },
    openModal() {
      $("#modal_validate_restock").modal("show");
      this.hasPermission = true;
    },
    closeModal() {
      $("#modal_validate_restock").modal("hide");
    },
    previous() {
      this.closeModal();
      this.$parent.isRestockModal = true;
      $("#modal_validate_restock").on("hidden.bs.modal", (e) => {
        $("#ModalRestock").modal("show");
      });
    },
  },
};
</script>

<style scope>
.table-hover .custom-vuetb tbody tr:hover {
    background-color: transparent;
}
.customvuetb tr > td {
    vertical-align: top;
}
table.custom-vuetb-data,
th.custom-vuetb{
  text-align: left;
}
.custom-vuetb-data tr > td {
    white-space: normal !important;
}

.table-hover tbody .custom-vuetb-shipmentdata tr:hover{
    color: #333;
    background-color: transparent;
}
table.custom-vuetb-shipmentdata td {
  border: none;
  padding: 0.25rem 1.25rem;
}
</style>



// WEBPACK FOOTER //
// src/layouts/tenancy/admin/restock/ModalValidateRestock.vue